export enum EmailDomain {
  Gmail = 'Gmail',
  Yahoo = 'Yahoo!',
  Outlook = 'Outlook',
  Apple = 'Apple Mail',
}

export enum ProductDomain {
  LiveChat = 'www.livechat.com',
  KnowledgeBase = 'www.knowledgebase.com',
  HelpDesk = 'www.helpdesk.com',
  ChatBot = 'www.chatbot.com',
  OpenWidget = 'www.openwidget.com',
  TextApp = 'www.text.com',
}
